import { Injectable, Injector } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "../authentication/authentication.service";
import { UserToken } from "./token";

@Injectable({
  providedIn: "root"
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authenticationService = this.injector.get(AuthenticationService);
    if (authenticationService != null) {
      let userToken: UserToken = this.injector.get(AuthenticationService).getUserToken();
      if (userToken.isLoggedIn()) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${userToken.brutToken}`
          }
        });
      }
    }

    return next.handle(request);
  }
}
